import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { getUserDetails } from "../../services/authService";
import "./TopSection.css";
const DEFAULT_AVATAR = "/icons/default_user.png";
export default function TopSection({ title, userData: initialUser }) {
  const history = useHistory();
  const userId  = initialUser?.id || localStorage.getItem("user_id");
  const userType  = initialUser?.management_type || localStorage.getItem("management_type");



  const [user,   setUser]   = useState(initialUser || null);
  const [busy,   setBusy]   = useState(false);

  /* fetch only if we don’t already have a user obj */
  useEffect(() => {
    if (user || !userId) return;
    let cancel = false;
    setBusy(true);
    (async () => {
      try {
        const res = await getUserDetails(userId);

        if (!cancel && res.success) setUser(res.user);
      } finally {
        if (!cancel) setBusy(false);
      }
    })();
    return () => { cancel = true; };
  }, [user, userId]);

  const avatar = user?.photographer_profile?.image_url || DEFAULT_AVATAR;

  const openProfile = () => {
    if (!user) return;
    history.push(`/user-details/${user.id}`, { to_update: false, userData: user });
  };

  return (
    <div
      className="top-section-guest blur-background blur-top"
      style={{ "--circle-size": "2000px", "--translate-x": "30%", "--translate-y": "30%" }}
    >
      <div className="logo-container-top-guest">
        <Link to="/">
          <img src="/icons/logo.png" className="logo" alt="Heyi" />
        </Link>
        {/* {user?.management_type === "photographer" && (
        <div
          className="user-image-container-event"
          onClick={openProfile}
          style={{ cursor: busy ? "default" : "pointer", opacity: busy ? 0.4 : 1 }}
        >
          <img src={avatar} className="user-avatar" alt="User" />
        </div>
      )} */}

      </div>

      {/* <img className="top-background-image-guest" src="/images/0N5A4100.jpg" alt="" /> */}

      <div className="top-title-guest">
        {title.split("\n").map((t, i) => (
          <span key={i} className={`title-line line-${i + 1}`}>{t}</span>
        ))}
      </div>
    </div>
  );
}
